import { render, staticRenderFns } from "./XFormDateTime.vue?vue&type=template&id=4dd501ba&"
import script from "./XFormDateTime.vue?vue&type=script&lang=js&"
export * from "./XFormDateTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports